const formatTIN = (value) => {
    if (value !== undefined) {
        let val = value.replace(/\D/g, "");
        let newVal = "";
        if (val.length > 3) {
            value = val;
        }
        if (val.length > 2 && val.length < 10) {
            newVal += `${val.substr(0, 2)}-`;
            val = val.substr(2);
        }
        return newVal + val;
    }
    return "";
};

export default formatTIN;
